import React, { useState, useEffect, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { useLocation, useNavigate } from 'react-router-dom';

// Componentes
import Mensaje from './Mensaje';
import Provincia from './Provincia';
import JuanaManso from './JuanaManso';
import AprenderConectado from './Nacion';
import Nacion from './Nacion';
import Descargas from './Descargas';

import VacacionesFormulario from "./VacacionesFormulario";


const options = [
  { id: 0, component: Mensaje,           imageSrc: require('../assets/img/provincia2.jpg'), title: 'Mensaje' },
  { id: 1, component: Provincia,         imageSrc: require('../assets/img/provincia2.jpg'), title: 'Provincia' },
  { id: 2, component: JuanaManso,        imageSrc: require('../assets/img/juana2.jpg'),     title: 'Conectar Igualdad (2019-actualidad)' },
  { id: 3, component: AprenderConectado, imageSrc: require('../assets/img/aprender2.jpg'),  title: 'Aprender Conectados' },
  { id: 4, component: Nacion,            imageSrc: require('../assets/img/nacion2.jpg'),    title: 'Conectar Igualdad (hasta 2018)' },
  { id: 5, component: Descargas,         imageSrc: require('../assets/img/Descargar.png'),  title: 'Descargas' },
];

// slugs de raíz (sin /desbloqueos)
const slugToIndex = {
  mensaje: 0,
  provincia: 1,
  juanamanso: 2,
  aprender: 3,
  nacion: 4,
  descargas: 5,
};
const indexToSlug = Object.fromEntries(Object.entries(slugToIndex).map(([k, v]) => [v, k]));

const Inicio = ({ initialPage = 0 }) => {
  const { instance, accounts } = useMsal();
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const containerRef = useRef(null);
  const [userEmail, setUserEmail] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (containerRef.current) containerRef.current.focus();
  }, [currentPage]);

useEffect(() => {
  setIsAuthenticated(accounts.length > 0);

  if (accounts.length > 0) {
    setUserEmail(accounts[0].username || null);
  } else {
    setUserEmail(null);
  }
}, [accounts]);


  // Tomar el slug directamente de la raíz: /provincia, /juanamanso, etc.
  useEffect(() => {
    const path = (location.pathname || '/').toLowerCase();
    // "" o "/" -> no forzar; dejá initialPage o lo que ya esté seleccionado
    const slug = path.replace(/^\/+/, '');
    if (!slug) return;

    const idx = slugToIndex[slug];
    if (typeof idx !== 'number') return;

    if (idx === 1 && !isAuthenticated) {
      localStorage.setItem('requestedPage', String(idx));
      instance.loginRedirect().catch(console.error);
      return;
    }
    setCurrentPage(idx);
  }, [location.pathname, isAuthenticated, instance]);

  // Deep-link post login
  useEffect(() => {
    const savedPage = localStorage.getItem('requestedPage');
    if (savedPage) {
      setCurrentPage(parseInt(savedPage, 10));
      localStorage.removeItem('requestedPage');
    }
  }, []);

  const scrollToContent = () => {
    const contentElement = document.querySelector('.contOption');
    if (contentElement) contentElement.scrollIntoView({ behavior: 'smooth' });
  };

  const handlePageChange = (pageIndex) => {
    if (pageIndex === 1 && !isAuthenticated) {
      localStorage.setItem('requestedPage', pageIndex);
      instance.loginRedirect().catch(console.error);
      return;
    }

    setCurrentPage(pageIndex);
    scrollToContent();

    // SIEMPRE actualizamos el slug de raíz (sin /desbloqueos)
    const slug = indexToSlug[pageIndex] || 'mensaje';
    navigate(`/${slug}`, { replace: false });
  };

  const CurrentComponent = options[currentPage]?.component || Mensaje;

  const recargar = () => handlePageChange(2); // atajo a JuanaManso si querés

  return (
    <main className="container my-4">
      <div className="row">
        <div className="col-md-3">
          <div className="card contMenu">
            <div className="card-body">
              <div className="row">
                <div className="col-12 text-center" onClick={recargar}>
                  <h6 className="card-title">Elija una opción:</h6>
                </div>
              </div>
            </div>
          </div>

          <div className="menu mt-3">
            {options.map(option => (
              <div
                key={option.id}
                className={`menu-item ${currentPage === option.id ? 'active' : ''} ${option.id === 0 ? 'd-none' : ''}`}
                onClick={() => handlePageChange(option.id)}
              >
                <img src={option.imageSrc} alt={`Opción ${option.id}`} className="img-fluid" />
                <p className="menu-title-item text-center">{option.title}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="col-md-9">
          <hr />
          <div className="container contOption" ref={containerRef} tabIndex="0">
            <CurrentComponent userEmail={userEmail} />

          </div>
        </div>
      </div>
    </main>
  );
};

export default Inicio;
